import React from "react";
import { Button, Checkbox, Grid, Typography } from "@mui/material";
import RightIcon from "@mui/icons-material/KeyboardArrowRight";
import { checkPermission } from "../../../Utils/Permissions";

export function CategoryList({
  onClick,
  category,
  selected,
  onChange,
  approved,
  onEdit,
  count,
}) {
  return (
    <Grid
      onClick={onClick}
      sx={{
        cursor: "pointer",
        backgroundColor: selected ? "white" : "transparent",
      }}
      alignItems="center"
      minHeight="55px"
      boxShadow={selected ? "rgba(149, 157, 165, 0.2) 0px 5px 20px;" : "none"}
      border={`1px solid ${selected ? "#e7eef6" : "lightgray"}`}
      borderRadius="10px"
      container
      marginBottom={selected ? 3 : 1}
      item
      lg={12}
    >
      <Grid container item lg={5}>
        <Typography
          fontSize={{ sm: "12px", md: "13px" }}
          fontWeight={500}
          paddingLeft="15px"
        >
          {category}
        </Typography>
        {count && (
          <Typography
            fontSize={{ sm: "12px", md: "13px" }}
            color="#1ac1a2"
            paddingLeft="5px"
          >
            ({count})
          </Typography>
        )}
      </Grid>
      <Grid item lg={4}>
        <Grid container alignItems={"center"} justifyContent="start">
          {checkPermission("DB_TREATMENT_APPROVAL") && (
            <Checkbox
              checked={approved}
              onChange={onChange}
              inputProps={{
                "aria-label": "controlled",
              }} // value={rowItem.id}
              sx={{
                "& .MuiSvgIcon-root": { color: "#17DFBA" },
              }}
            />
          )}
          <Typography color={"#4C5A6A"} fontSize={{ md: "13px", sm: "12px" }}>
            {approved ? "Approved" : "Pending"}
          </Typography>
        </Grid>
      </Grid>
      <Grid
        container
        justifyContent="flex-end"
        alignItems="center"
        paddingRight="15px"
        item
        lg={3}
      >
        {checkPermission("DB_CATEGORY_EDIT") && (
          <Button
            onClick={onEdit}
            sx={{
              backgroundColor: "#f2f9f6",
              border: "1px solid #83BEA2",
              borderRadius: "30px",
              height: "25px",
              color: "black",
              minWidth: "54px",
              textTransform: "capitalize",
              fontSize: "13px",
            }}
          >
            Edit
          </Button>
        )}
        <RightIcon />
      </Grid>
    </Grid>
  );
}
